import { BrandCode } from 'types';
import { DEFAULT_LOCALE } from '../../../../globalization/Locale/Constants';

/**
 * Converts a URL path to a market identifier.
 * @param path The URL path (e.g., "/mex/es", "/mx")
 * @param brandCode The brand code (e.g., BrandCode.Celebrity)
 * @returns The market identifier (e.g., "mex", "mx")
 */
export const pathToMarket = (path, brandCode) => {
	let _path = path ?? DEFAULT_LOCALE.path ?? '';

	// Remove leading slash if present
	if (_path.startsWith('/')) {
		_path = _path.substring(1);
	}

	if (!_path) {
		_path = brandCode === BrandCode.Celebrity ? 'us' : 'usa';
	}

	// Split the path by '/' and return the first segment
	const segments = _path.split('/');
	return (segments.length > 0 ? segments[0] : '').toLowerCase();
};
